import type { NavigateFunction } from "react-router-dom";
import type { Dispatch, SetStateAction } from "react";
import { GroupOption } from "../types";

/**
 * Factory that returns an `applyGrouping(value)` fn.
 * All URL + state logic is inside here.
 */
function createApplyGrouping(
	navigate: NavigateFunction,
	pathname: string,
	search: string,
	paramName: string,
	groupOptions: GroupOption[],
	setAppliedGroup: Dispatch<SetStateAction<string>>,
	setPendingGroup: Dispatch<SetStateAction<string>>,
	setIsModalOpen: Dispatch<SetStateAction<boolean>>
): (value: string) => void {
	// return (value: string) => {
	// 	const sel = groupOptions.find(
	// 		(groupOption) => groupOption.tableSlugs.primaryTableSlug === value
	// 	);

	// 	if (!sel) return;

	// 	if (
	// 		sel?.tableSlugs.primaryTableSlug === "inventory_items-customerPos"
	// 	) {
	// 		const params = new URLSearchParams();
	// 		// Set your desired query parameters
	// 		params.set(
	// 			`${sel.tableSlugs.alternativePrimaryTableSlug}_recordsPerPage`,
	// 			"15"
	// 		);
	// 		params.set(
	// 			`${sel.tableSlugs.alternativePrimaryTableSlug}_page`,
	// 			"1"
	// 		);
	// 		// Optionally add UUID (if you still need it)
	// 		params.set(
	// 			`${sel.tableSlugs.alternativePrimaryTableSlug}:group`,
	// 			sel.uuid
	// 		);
	// 		// Build the full URL (including host)
	// 		// const fullUrl = `${window.location.origin}${pathname}?${params.toString()}`;
	// 		const fullUrl = `${
	// 			window.location.origin
	// 		}${pathname}?${params.toString()}`;
	// 		//Save the selected value in localStorage
	// 		localStorage.setItem("selectedGrouping", JSON.stringify(sel));

	// 		// Set UI states
	// 		setAppliedGroup(value);
	// 		setPendingGroup(value);
	// 		setIsModalOpen(false);

	// 		// Wait a tick before hard redirect so local storage and states are set
	// 		setTimeout(() => {
	// 			window.location.href = fullUrl;
	// 		}, 500);
	// 	} else {
	// 		const params = new URLSearchParams();
	// 		// Set your desired query parameters
	// 		params.set(
	// 			`${sel.tableSlugs.primaryTableSlug}_recordsPerPage`,
	// 			"15"
	// 		);
	// 		params.set(`${sel.tableSlugs.primaryTableSlug}_page`, "1");
	// 		// Optionally add UUID (if you still need it)
	// 		params.set(`${sel.tableSlugs.primaryTableSlug}:group`, sel.uuid);
	// 		// Build the full URL (including host)
	// 		// const fullUrl = `${window.location.origin}${pathname}?${params.toString()}`;
	// 		const fullUrl = `${
	// 			window.location.origin
	// 		}${pathname}?${params.toString()}`;
	// 		//Save the selected value in localStorage
	// 		localStorage.setItem("selectedGrouping", JSON.stringify(sel));

	// 		// Set UI states
	// 		setAppliedGroup(value);
	// 		setPendingGroup(value);
	// 		setIsModalOpen(false);

	// 		// Wait a tick before hard redirect so local storage and states are set
	// 		setTimeout(() => {
	// 			window.location.href = fullUrl;
	// 		}, 500);
	// 	}
	// };
	return (value: string) => {
		const sel = groupOptions.find(
			(groupOption) => groupOption.tableSlugs.primaryTableSlug === value
		);
		if (!sel) return;

		const { primaryTableSlug, alternativePrimaryTableSlug } =
			sel.tableSlugs;

		// need this bc two table view use the same slug
		const useAltSlug = primaryTableSlug === "inventory_items-customerPos";
		const tableSlug = useAltSlug
			? alternativePrimaryTableSlug
			: primaryTableSlug;

		const params = new URLSearchParams();
		params.set(`${tableSlug}_recordsPerPage`, "15");
		params.set(`${tableSlug}_page`, "1");
		params.set(`${tableSlug}:group`, sel.uuid);

		localStorage.setItem("selectedGrouping", JSON.stringify(sel));
		setAppliedGroup(sel.uuid);
		setPendingGroup(sel.uuid);
		setIsModalOpen(false);

		const fullUrl = `${
			window.location.origin
		}${pathname}?${params.toString()}`;
		setTimeout(() => {
			window.location.href = fullUrl;
		}, 500);
	};
}

export default createApplyGrouping;
